import { render, staticRenderFns } from "./browse-space-details.vue?vue&type=template&id=6ea4d69f"
import script from "./browse-space-details.vue?vue&type=script&lang=js"
export * from "./browse-space-details.vue?vue&type=script&lang=js"
import style0 from "./browse-space-details.vue?vue&type=style&index=0&id=6ea4d69f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports